import { BaseTemplate } from "../baseTemplate";
import { shortReportingYear, subjectForList, SIGNATURE, getReportingYear } from "./shared";
const NNR_RAW_TEMPLATE_PLACEHOLDER = "Newly-not-reporting cover letter (content from template).";
export class BaseNewlyNotReportingTemplate extends BaseTemplate {
    toTemplate() {
        return {
            id: this.id,
            subject: this.subject.bind(this),
            text: this.text.bind(this),
            rawTemplate: () => NNR_RAW_TEMPLATE_PLACEHOLDER,
            extractVariables: () => ({}),
        };
    }
    shortReportingYear(year) {
        return shortReportingYear(year);
    }
    subjectForList(organizationName, reportingYear) {
        return subjectForList(organizationName, reportingYear);
    }
    get signature() {
        return SIGNATURE;
    }
    buildSubject(communication) {
        return this.subjectForList(communication.tenant.name, getReportingYear(communication));
    }
}
//# sourceMappingURL=baseNewlyNotReportingTemplate.js.map